var styles = {"fontElementMap":"HHAfl","orderedlist":"xGdbD","bulletedlist":"j-30L","listItem":"OhaEV"};

export { styles as s };
//# sourceMappingURL=lists-0f8b57cc.js.map
